var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConfigurableDashboard',{attrs:{"dashboard-key":"main","permission-key":"Dashboard","default-widgets":['news']}})
}
var staticRenderFns = []

export { render, staticRenderFns }